import styled from "styled-components";

export const HeaderContainerMobile = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  justify-content: space-around;
  height: 44px;
  box-sizing: border-box;
  align-items: center;
  height: 44px;
  background: #f6f6f6;
  color: #4d4d4d;
`;
